import { getAggregatorOrderStock } from "../services";

// TSK-3229: order-scoped, per-line stock + modifiability for the Aggregator
// screen, via getAggregatorOrderStock. Deliberately separate from
// PointOfSale/Core/stock.js, which is cart-shaped (BOM drawers, negative-stock
// config, batch consolidation) and not a fit here. Keyed by sOrderlineId, not
// productId — two lines can carry the same product and must be judged per line.
export const checkAggregatorItemsStock = async (tillId, sOrderId) => {
  if (!sOrderId) return { modifiable: "N", reason: null, stockMap: {} };

  try {
    const response = await getAggregatorOrderStock(tillId, sOrderId);
    const orderStock = response?.data?.data?.getAggregatorOrderStock;
    const items = orderStock?.items || [];
    const stockMap = {};
    items.forEach((it) => {
      stockMap[it.sOrderlineId] = {
        availabilityStatus: it.availabilityStatus,
        sellableQty: it.sellableQty,
        onhandQty: it.onhandQty,
      };
    });
    return {
      modifiable: orderStock?.modifiable || "N",
      reason: orderStock?.reason || null,
      stockMap,
    };
  } catch (error) {
    console.error("Error checking aggregator order stock:", error);
    return { modifiable: "N", reason: null, stockMap: {} };
  }
};

// Per the solution doc: show the "Out of Stock" badge on anything whose
// availabilityStatus is not "Yes" (covers both "Partial" and "No").
export const isItemOutOfStock = (item, stockMap) => {
  if (!item?.sOrderlineID) return false;
  const entry = stockMap?.[item.sOrderlineID];
  if (!entry) return false;
  return entry.availabilityStatus !== "Yes";
};